import axios from 'axios'

let cachedIp = null

export const getPublicIp = async () => {
  if (cachedIp) return cachedIp
  try {
    const resp = await axios.get('https://api.ipify.org?format=json')
    cachedIp = resp.data.ip
    return cachedIp
  } catch {
    return null
  }
}
